import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, get } from 'lodash';
import { PageTypes } from '@sparefoot/segment-react';

import { Card } from 'components/legacy/Card';
import { Accordion } from 'components/search/Accordion';
import { MarkdownWrapper } from 'components/search/MarkdownWrapper';
import BestPricedUnits from './BestPricedUnits';
import CityLinks from './CityLinks';
import NearbyCities from './NearbyCities';


import './searchContent.scss';

export default function SearchContent({
	content, location, pageType, faqContent, faqShowing
}) {
	const { seoBodyJson } = content;

	return (
		<Fragment>
			{ seoBodyJson &&
				<Card>
					<MarkdownWrapper
						content={seoBodyJson}
					/>
				</Card>
			}
			{faqShowing &&
			<Card>
				<Accordion
					accordionTitle="Frequently asked questions"
					content={faqContent}
					segmentCategory="clp faq"
					isFAQ
					className="faq-content"
					preserve
				/>
			</Card>
			}
			{pageType === PageTypes.CITY_LANDING && !isEmpty(location) &&
				<BestPricedUnits
					location={location}
					pricingStats={content.pricingStats}
				/>
			}
			{pageType !== PageTypes.CITY_LANDING && !isEmpty(get(content, 'cityLinks.nearbyCities')) &&
				<NearbyCities
					title={`Browse Storage in other ${location.fullState} cities`}
					links={content.cityLinks.nearbyCities}
					segmentCategory="browse storage in other cities widget interactions"
				/>
			}
			{!isEmpty(get(content, 'cityLinks.amenities')) &&
				<CityLinks
					title={`Browse ${location.city} Storage by Amenity`}
					links={content.cityLinks.amenities}
					city={location.city}
					segmentCategory="browse city storage by amenity widget interactions"
					segmentLabel="amenity"
				/>
			}
			{!isEmpty(get(content, 'cityLinks.vehicleStorage')) &&
				<CityLinks
					title={`Browse ${location.city} Vehicle Storage`}
					links={content.cityLinks.vehicleStorage}
					city={location.city}
					segmentCategory="browse city vehicle storage widget interactions"
					segmentLabel="vehicle"
				/>
			}

		</Fragment>
	);
}

SearchContent.propTypes = {
	content: PropTypes.shape({
		bestPricedUnits: PropTypes.arrayOf(
			PropTypes.object,
		)
	}),
	location: PropTypes.shape({
		city: PropTypes.string,
		state: PropTypes.string
	}).isRequired,
	pageType: PropTypes.string,
	searchParams: PropTypes.shape({
		type: PropTypes.string,
		vehicle: PropTypes.string
	}).isRequired,
	faqContent: PropTypes.arrayOf(PropTypes.object),
	faqShowing: PropTypes.bool
};
